import { useLanguage } from '@/hooks/useLanguage';
import { tx as translateInterfaceText } from '@/utils/i18n';

import React from 'react';
import { Button } from '@/components/ui/button';
import { Upload, Plus } from 'lucide-react';

interface EmptyStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  isReadOnly?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = translateInterfaceText("Nenhum vídeo encontrado"),
  description = translateInterfaceText("Comece enviando seu primeiro vídeo."),
  actionLabel = translateInterfaceText("Enviar vídeo"),
  onAction,
  className,
  isReadOnly = false,
}) => {
  useLanguage();
  return (
    <div className={`flex flex-col items-center justify-center text-center p-12 ${className}`}>
      <div className="rounded-full bg-primary/10 p-6 mb-6">
        <Upload className="w-12 h-12 text-primary" />
      </div>
      
      <h2 className="text-2xl font-semibold mb-2">{title}</h2>
      <p className="text-muted-foreground mb-6 max-w-md">{description}</p>
      
      {!isReadOnly && onAction && (
        <Button onClick={onAction} className="flex items-center gap-2">
          <Plus className="w-4 h-4" />
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
